import moment from 'moment';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import classes from './MaintenanceLogHistory.module.scss';

const MaintenanceLog = () => {
  const { t: translate } = useTranslation();
  const { SmLogHistoryDetails } = useSelector(
    (state: any) => state?.LogHistory
  );

  const formatDate = (timestamp: string) => {
    const formattedDate = moment(timestamp).format('MMMM D, h:mm A');
    return formattedDate;
  };

  const convertToTitleCase = (str: string) => {
    const status = str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    return status;
  };

  const formatStartEndDate = (timestamp: string) => {
    const formattedDate = moment(timestamp).format('ddd MM/DD/YYYY h:mm A');
    return formattedDate;
  };
  const monthName = (timestamp: string) => moment(timestamp).format('MMMM');

  return (
    <div className={classes.container}>
      {SmLogHistoryDetails.length === 0 && (
        <div className={classes.maintenanceName}>
          {translate('maintenance_table.txt_no_log_history')}
        </div>
      )}
      {SmLogHistoryDetails.length > 0 && SmLogHistoryDetails[0].serviceAuditMaintenance && (
        <>
          <div className={classes.modalTitle}>{monthName(SmLogHistoryDetails[0].startTimestamp)} {translate('maintenance_table.txt_maintenance')}</div>
          <div className={classes.modalDesc}>{formatStartEndDate(SmLogHistoryDetails[0].startTimestamp)} {translate('maintenance_table.txt_to')} {formatStartEndDate(SmLogHistoryDetails[0].endTimestamp)}</div>

          <div className={classes.statusTable}>
            {SmLogHistoryDetails[0].serviceAuditMaintenance.map((item: any) => (
              <Row key={item.maintenanceTime} className={classes.tableRow}>
                <Col className={classes.maintenanceTime}>
                  {formatDate(item.createdTimeStamp)}
                </Col>
                <Col className={classes.maintenanceName}>
                  {item.createdBy}
                </Col>
                <Col className={classes.maintenanceTime}>
                  {convertToTitleCase(item.maintenanceStatus)}
                </Col>
              </Row>
            ))}
          </div>
        </>
      )}

    </div>

  );
};

export default MaintenanceLog;
